import styled from "@emotion/styled";
import { fontRoboto } from "@product/scmp-sdk";

type Props = {
  $isSelected: boolean;
};

export const Option = styled.li<Props>`
  padding-block: 9px;
  padding-inline: 14px;

  color: #000000;
  font-weight: ${props => (props.$isSelected ? "700" : "400")};
  font-size: 16px;
  font-family: ${fontRoboto};
  line-height: 19px;

  &:hover {
    background-color: rgba(69, 133, 255, 0.1);
  }
`;
